// Migrated from app/assets/javascripts/service_cost.js.coffee
// Converted from CoffeeScript to JavaScript

var COST = {
  price_per_ticket: {fixed_excl: 0.75},
  vat_percentage: 1.21,
  payment_methods: {
    sisow: {
      ideal:                 {fixed_excl: 0.45},
      bank_transfer:         {fixed_excl: 0.35},
      bancontact:            {fixed_excl: 0.25, percentage_excl: 0.018},
      sofortbanking:         {fixed_excl: 0.15, percentage_excl: 0.01, min_value_excl: 0.25},
      paypal:                {fixed_excl: 0.25, fixed_incl: 0.35, percentage_incl: 0.034}
    },
    paynl: {
      // ideal
      10:                    {fixed_excl: 0.39},
      // overboeking
      136:                   {fixed_excl: 0.39},
      // paypal
      138:                   {fixed_excl: 0.21, fixed_incl: 0.35, percentage_incl: 0.034},
      // mistercash_bancontact
      436:                   {fixed_excl: 0.20, percentage_excl: 0.0175},
      // sofortbanking
      559:                   {fixed_excl: 0.41, percentage_excl: 0.01},
      // giropay
      694:                   {fixed_excl: 0.31, percentage_excl: 0.025},
      // visa / mastercard
      706:                   {fixed_excl: 0.29, percentage_excl: 0.03},
      // my_bank
      1588:                  {fixed_excl: 0.20, percentage_excl: 0.0175},
      // yourgift
      1645:                  {fixed_excl: 0.21, percentage_excl: 0.1},
      // amex
      1705:                  {fixed_excl: 0.29, percentage_excl: 0.028},
      // amex2
      2017:                  {fixed_excl: 0.29, percentage_excl: 0.028},
      // apple pay
      2277:                  {fixed_excl: 0.29, percentage_excl: 0.03},
      // google pay
      2558:                  {fixed_excl: 0.29, percentage_excl: 0.03}
    }
  }
};

window.ServiceCost = {
  calc: function(psp, subtotal, nr_tickets, payment_method) {
    var cost_payment = 0;
    var cost_tickets = this.service_cost_tickets(nr_tickets);
    if (subtotal > 0 && nr_tickets > 0) {
      cost_payment = this.service_cost_payment(psp, payment_method, subtotal + cost_tickets);
    }
    return cost_tickets + cost_payment;
  },

  service_cost_tickets: function(nr_tickets) {
    return nr_tickets * COST.price_per_ticket.fixed_excl * COST.vat_percentage;
  },

  service_cost_payment: function(psp, _payment_method, subtotal) {
    var payment_method = _payment_method.toString();
    var payment_cost = COST.payment_methods[psp][payment_method];
    var a, b, c, total_incl;

    switch (payment_method) {
      case 'ideal':
      case '10':
      case 'bank_transfer':
      case '136':
        return payment_cost.fixed_excl * COST.vat_percentage;
      case 'bancontact':
      case '436':
      case '559':
      case '694':
      case '706':
      case '1588':
      case '1645':
      case '1705':
      case '2017':
      case '2277':
      case '2558':
        a = 1 - payment_cost.percentage_excl * COST.vat_percentage;
        b = 1 / a;
        c = subtotal + payment_cost.fixed_excl * COST.vat_percentage;
        total_incl = b * c;
        if (payment_method === 'sofortbanking' || payment_method === '559') {
          // sofortbanking special case already handled by case grouping above
        }
        return total_incl - subtotal;
      case 'sofortbanking':
        a = 1 - payment_cost.percentage_excl * COST.vat_percentage;
        b = 1 / a;
        c = subtotal + payment_cost.fixed_excl * COST.vat_percentage;
        total_incl = b * c;
        if (total_incl >= 10) {
          return total_incl - subtotal;
        } else {
          return payment_cost.min_value_excl * COST.vat_percentage;
        }
      case 'paypal':
      case '138':
        a = 1 - payment_cost.percentage_incl;
        b = 1 / a;
        c = subtotal + (payment_cost.fixed_excl * COST.vat_percentage) + payment_cost.fixed_incl;
        total_incl = b * c;
        return total_incl - subtotal;
      default:
        return 'N/A';
    }
  }
};
